<template>
    <v-card class="legend-ui" :style="{ scale: uncertainty ? '1' : '1.18' }">

       
        <v-card-item v-if="classIntervalsAndColor" >
            <div class="legend-item">
                <div class="color-strip strip1"  :style="{ backgroundColor: classIntervalsAndColor[0]['color1']}"></div>
                <div class="legend-label">{{ minMax[0] }}</div>
            </div>
            <div class="legend-item">
                <div class="color-strip strip2" :style="{ backgroundColor: classIntervalsAndColor[1]['color2']}"></div>
                <div class="legend-label">{{ classIntervalsAndColor[0]['interval1'] }}</div>
            </div>
            <div class="legend-item">
                <div class="color-strip strip3" :style="{ backgroundColor: classIntervalsAndColor[2]['color3']}"></div>
                <div class="legend-label">{{ classIntervalsAndColor[1]['interval2'] }}</div>
            </div>
            <div class="legend-item">
                <div class="color-strip strip4" :style="{ backgroundColor: classIntervalsAndColor[3]['color4']}"></div>
                <div class="legend-label">{{ classIntervalsAndColor[2]['interval3'] }}</div>
            </div>
            <div class="legend-item">
                <div class="color-strip strip5" :style="{ backgroundColor: classIntervalsAndColor[4]['color5']}"></div>
                <div class="legend-label">{{ classIntervalsAndColor[3]['interval4'] }}</div>
                <div class="legend-label-max">{{ minMax[1] }}</div>
            </div>
        </v-card-item>
        <v-card-item v-if="rasterLegendUrl">
            <div class="mb-2">
                <v-icon
                        size="small"
                        variant="text"
                        density="compact"
                        @click="showMetadata(rasterLegendTitle)"
                    >
                    <font-awesome-icon :icon="['fas', 'circle-info']" />
                </v-icon>
                {{rasterLegendTitle}}
                
            </div>
            <div>
                 <img :src="rasterLegendUrl" alt="Legend" />
            </div>
        </v-card-item>
        <v-card-item  v-if="activatedGeovisStyle === 'bivariate'">
            <div class="bivariate-legend-container">
                <span  style="text-orientation: mixed;  writing-mode: vertical-rl; "> 
                        
                       {{firstProperties }}
                </span>
                    
                <div class="bivariate-y-axis">
                    <span>High</span>
                    <span style="font-weight: bold; font-size: 1.5rem;">&uarr;</span>
                    <span>Low</span>
                        
                 </div>
                    
                    

                <!-- Legend Grid -->
                <div class="bivariate-legend">
                
                    <div class="bivariate-legend-grid">
                        <div
                            v-for="(color, index) in bivariateColorpalette"
                            :key="index"
                            :id="'bivariate'+index"
                            :style="{ backgroundColor: color }"
                            class="bivariate-legend-cell"
                        >
                        <!--<span class="bivariate-legend-label">{{ key.replace('_', ' / ') }}</span>-->
                        </div>
                    </div>

                    <!-- X-axis Labels and Arrow -->
                    <div class="bivariate-x-axis">
                        <span>Low</span>
                        
                        <span style="font-weight: bold; font-size: 1.5rem;">&rarr;</span>
                        
                        <span>High</span>
                    </div>
                    <span> 
                    
                    {{ secondProperties }}
                    </span>
                    
                
                    
                </div>
            </div>
        </v-card-item>
          <!-- Legend for ink circle uncertainty -->
        <v-card-item style="font-size: 0.7rem;" v-if=" uncertaintyStyle === 'ink' && (activatedGeovisStyle === 'circle'||activatedGeovisStyle === 'bivariate')">
          <div class="legend-item mr-1">
            <div class="ink-circle ink-level-very-low"></div>
            <span>Very Low</span>
          </div>
          <div class="legend-item mr-1">
            <div class="ink-circle ink-level-low"></div>
            <span>Low</span>
          </div>
          <div class="legend-item mr-1">
            <div class="ink-circle ink-level-medium"></div>
            <span>Medium</span>
          </div>
          <div class="legend-item mr-1">
            <div class="ink-circle ink-level-high"></div>
            <span>High</span>
          </div>
          <div class="legend-item">
            <div class="ink-circle ink-level-very-high"></div>
            <span>Very High</span>
          </div>
          <div class="font-weight-bold">
            Uncertainty
          </div>
        </v-card-item>
         <!-- Legend for fuzzy circle uncertainty -->
        <v-card-item style="font-size: 0.7rem;"  v-if="uncertaintyStyle === 'fuzzy' && (activatedGeovisStyle === 'circle'||activatedGeovisStyle === 'bivariate')">
            <div class="legend-item mr-1">
                <div class="fuzzy-circle level-very-low"></div>
                <span>Very Low</span>
            </div>
            <div class="legend-item mr-1">
                <div class="fuzzy-circle level-low"></div>
                <span>Low</span>
            </div>
            <div class="legend-item mr-1">
                <div class="fuzzy-circle level-medium"></div>
                <span>Medium</span>
            </div>
            <div class="legend-item mr-1">
                <div class="fuzzy-circle level-high"></div>
                <span>High</span>
            </div>
            <div class="legend-item">
                <div class="fuzzy-circle level-very-high"></div>
                <span>Very High</span>
            </div>
            <div class="font-weight-bold">
                Uncertainty
            </div>
            
        </v-card-item>
        <!-- Legend for Circle position uncertainty -->
        <v-card-item v-if="uncertaintyStyle === 'position' && (activatedGeovisStyle === 'circle'||activatedGeovisStyle === 'bivariate')">
            <div class="circle">
              <div class="point center"></div>
              <div class="label center-label">Certain</div>
              <div class="point edge"></div>
              <div class="label edge-label">Uncertain</div>
              <div class="arrow"></div>
              </div>
              <div class="font-weight-bold">
              Uncertainty
            </div>
        </v-card-item>
        <!-- Legend for Circle and Square styles that applies the first selected variable always mapped on color -->
        <v-card-item v-if="(activatedGeovisStyle === 'circle' || activatedGeovisStyle === 'square' || activatedGeovisStyle === 'arrow') && (legendVisVar1 === 'color' || legendVisVar2 === 'color')">
           
            <div class="legend-item">
                <div class="color-strip strip1"  :style="{ backgroundColor: selectedColorPalette.colors[0]}"></div>
                <div class="legend-label">{{  legendVisVar1 === 'color'?firstPropertiesClassIntervals[0].toFixed(2):secondPropertiesClassIntervals[0].toFixed(2)}}</div>
            </div>
            <div class="legend-item">
                <div class="color-strip strip2" :style="{ backgroundColor: selectedColorPalette.colors[1]}"></div>
                <div class="legend-label">{{ legendVisVar1 === 'color'?firstPropertiesClassIntervals[1].toFixed(2):secondPropertiesClassIntervals[1].toFixed(2) }}</div>
            </div>
            <div class="legend-item">
                <div class="color-strip strip3" :style="{ backgroundColor: selectedColorPalette.colors[2]}"></div>
                <div class="legend-label">{{ legendVisVar1 === 'color'?firstPropertiesClassIntervals[2].toFixed(2):secondPropertiesClassIntervals[2].toFixed(2) }}</div>
            </div>
            <div class="legend-item">
                <div class="color-strip strip4" :style="{ backgroundColor: selectedColorPalette.colors[3]}"></div>
                <div class="legend-label">{{ legendVisVar1 === 'color'?firstPropertiesClassIntervals[3].toFixed(2):secondPropertiesClassIntervals[3].toFixed(2) }}</div>
            </div>
            <div class="legend-item">
                <div class="color-strip strip5" :style="{ backgroundColor: selectedColorPalette.colors[4]}"></div>
                <div class="legend-label">{{ legendVisVar1 === 'color'?firstPropertiesClassIntervals[4].toFixed(2):secondPropertiesClassIntervals[4].toFixed(2) }}</div>
           
            </div>
            <div class="mb-0 font-weight-bold">
                {{legendVisVar1 === 'color'?firstProperties:secondProperties}}    
            </div>
        </v-card-item>
        <!-- Legend for Circle size -->
        <v-card-item style="font-size: 0.7rem;" v-if="(activatedGeovisStyle === 'circle'|| activatedGeovisStyle === 'square') && (legendVisVar1 === 'size' || legendVisVar2 === 'size')">
           
            <div class="legend-item mr-1">
                <div :class="[
                  activatedGeovisStyle === 'circle' ? 'circle-very-low' :
                  activatedGeovisStyle === 'square' ? 'square-very-low' : ''
                ]"></div>
               <div >{{  legendVisVar1 === 'size'?firstPropertiesClassIntervals[0].toFixed(2):secondPropertiesClassIntervals[0].toFixed(2)}}</div>
            </div>
            <div class="legend-item mr-6">
               <div :class="[
                  activatedGeovisStyle === 'circle' ? 'circle-low' :
                  activatedGeovisStyle === 'square' ? 'square-low' : ''
                ]"></div>
               <div >{{  legendVisVar1 === 'size'?firstPropertiesClassIntervals[1].toFixed(2):secondPropertiesClassIntervals[1].toFixed(2)}}</div>
            </div>
            <div class="legend-item mr-6">
               <div :class="[
                  activatedGeovisStyle === 'circle' ? 'circle-medium' :
                  activatedGeovisStyle === 'square' ? 'square-medium' : ''
                ]"></div>
               <div >{{  legendVisVar1 === 'size'?firstPropertiesClassIntervals[2].toFixed(2):secondPropertiesClassIntervals[2].toFixed(2)}}</div>
            </div>
            <div class="legend-item  mr-6">
                <div :class="[
                  activatedGeovisStyle === 'circle' ? 'circle-high' :
                  activatedGeovisStyle === 'square' ? 'square-high' : ''
                ]"></div>
               <div >{{  legendVisVar1 === 'size'?firstPropertiesClassIntervals[3].toFixed(2):secondPropertiesClassIntervals[3].toFixed(2)}}</div>
            </div>
            <div class="legend-item">
               <div :class="[
                  activatedGeovisStyle === 'circle' ? 'circle-very-high' :
                  activatedGeovisStyle === 'square' ? 'square-very-high' : ''
                ]"></div>
               <div >{{  legendVisVar1 === 'size'?firstPropertiesClassIntervals[4].toFixed(2):secondPropertiesClassIntervals[4].toFixed(2)}}</div>
           
            </div>
            <div class="mb-0 font-weight-bold">
               {{legendVisVar1 === 'size'?firstProperties:secondProperties}}        
            </div>
        </v-card-item>
        <!-- Legend for pattern size -->
        <v-card-item v-if="uncertaintyStyle==='pattern_width' && (activatedGeovisStyle === 'square'||activatedGeovisStyle === 'bivariate')">
          <div  v-for="(thickness, index) in stripeThicknesses"
            :key="index"
            style="font-size: 0.7rem; display: inline-block;">
            <div
              class="square-pattern-width legend-item "
              :class="index === 4 ? 'mr-0' : 'mr-6'"
              :style="getStripeStyle(thickness)"
            ></div>
          </div>
          <div class="legend-arrow-container mt-4">
              <div class="legend-arrow-label" style="float: left;">Certain</div>
              <div class="uncertainty-square-arrow"></div>
              <div class="legend-arrow-label" style="float: right;">Uncertain</div>
          </div>
          
        </v-card-item>
         <!-- Legend for noise width -->
        <v-card-item v-if="uncertaintyStyle==='noise_with_line_width' && (activatedGeovisStyle === 'square'||activatedGeovisStyle === 'bivariate')">
          <div  v-for="(thickness, index) in stripeThicknesses"
            :key="index"
            style="font-size: 0.7rem; display: inline-block;">
            <img
              class="legend-item"
              :class="index === 4 ? 'mr-0' : 'mr-6'"
              :src="`legend_items/noise_width_${index+1}.png`"
              style="width: 40px; height: 40px;"
            />
          </div>
          <div class="legend-arrow-container mt-4">
              <div class="legend-arrow-label" style="float: left;">Uncertain</div>
              <div class="uncertainty-square-arrow"></div>
              <div class="legend-arrow-label" style="float: right;">Certain</div>
          </div>
          
        </v-card-item>
        <!-- Legend for noise grain size -->
        <v-card-item v-if="uncertaintyStyle==='noise_with_grain_size' && (activatedGeovisStyle === 'square'||activatedGeovisStyle === 'bivariate')">
          <div  v-for="(thickness, index) in stripeThicknesses"
            :key="index"
            style="font-size: 0.7rem; display: inline-block;">
            <img
              class="legend-item"
              :class="index === 4 ? 'mr-0' : 'mr-6'"
              :src="`legend_items/noise_grain_${index+1}.png`"
              style="width: 40px; height: 40px;"
            />
          </div>
          <div class="legend-arrow-container mt-4">
              <div class="legend-arrow-label" style="float: left;">Uncertain</div>
              <div class="uncertainty-square-arrow"></div>
              <div class="legend-arrow-label" style="float: right;">Certain</div>
          </div>
          
        </v-card-item>
         <!-- Legend for pattern orientation -->
        <v-card-item v-if="uncertaintyStyle==='pattern_orientation' && (activatedGeovisStyle === 'square'||activatedGeovisStyle === 'bivariate')">
          <div  v-for="(angle, index) in stripeAngles"
            :key="index"
            style="font-size: 0.7rem; display: inline-block;">
            <div
              class="square-pattern-width legend-item "
              :class="index === 4 ? 'mr-0' : 'mr-6'"
              :style="getStripeAngleStyle(angle)"
            ></div>
          </div>
          <div class="legend-arrow-container mt-4">
              <div class="legend-arrow-label" style="float: left;">Uncertain</div>
              <div class="uncertainty-square-arrow"></div>
              <div class="legend-arrow-label" style="float: right;">Certain</div>
          </div>
          
        </v-card-item>

        <v-card-item v-if="activatedGeovisStyle === 'arrow'">
          <div class="arrow-wrapper">
              <div
                v-for="(height, index) in arrowVisHeights"
                :key="index"
                class="arrow-column"
              >
              <div
                  class="arrow-head"
                  :style="{
                    borderLeft: (arrowVisWidth[index] * 0.8) + 'px solid transparent',
                    borderRight: (arrowVisWidth[index] * 0.8) + 'px solid transparent',
                    borderBottom: (arrowVisWidth[index] * 0.8) + 'px solid black',
                  }"
                ></div>
                <div
                  class="arrow-vis"
                  :style="{ height: height + 'px', width: arrowVisWidth[index] + 'px' }"
                ></div>
                <div class="arrow-label">
                  {{  legendVisVar1 === 'size'?firstPropertiesClassIntervals[index].toFixed(2):secondPropertiesClassIntervals[index].toFixed(2)}}
                </div>
              </div>
               
          </div>
          <div class="mb-0 font-weight-bold">
               {{legendVisVar1 === 'size'?firstProperties:secondProperties}}        
            </div>
        </v-card-item>
        <!-- Legend for Circle position uncertainty -->
        <v-card-item v-if="uncertaintyStyle === 'orientation' && (activatedGeovisStyle === 'square'||activatedGeovisStyle === 'bivariate')">
            <div class="circle mt-4 mb-4">
               <div class="point center"></div>
              <div class="label arrow-vis-uncertainty-label">Certain</div>
              <div class="label arrow-vis-uncertainty-label-down">Uncertain</div>
              <div class="arrow-vis-uncertainty"></div>
              <div class="arrow-vis-uncertainty-low"></div>
              <div class="arrow-vis-uncertainty-medium"></div>
              <div class="arrow-vis-uncertainty-high"></div>
              <div class="arrow-vis-uncertainty-down"></div>
              </div>
             
        </v-card-item>
       <v-card-item v-if="activatedGeovisStyle === 'accumulative'">
        <div class="mb-4 font-weight-bold">
               Accumulative Feature       
            </div>
        <v-row class="pa-2" style="width: 160px;" dense>
          <v-col
            v-for="(color, feature) in accumulativeFeatureColor"
            :key="feature"
            cols="12"
            class="d-flex align-center"
          >
            <div
              :style="{
                backgroundColor: color,
                width: '20px',
                height: '20px',
                borderRadius: '4px',
                marginRight: '8px',
                border: '1px solid #ccc'
              }"
            ></div>
            <span class="text-body-2">{{ feature }}</span>
          </v-col>
        </v-row>
      </v-card-item>
      <!-- Legend for vector FFS -->
      <v-card-item v-if="ffs_layer_activated===true">
            <div class="legend-item">
                <div class="color-strip strip1"  :style="{ backgroundColor: ffsColors[0]}"></div>
                <div class="legend-label">{{  ffsClasses[0] }}</div>
            </div>
            <div class="legend-item">
                <div class="color-strip strip2" :style="{ backgroundColor:  ffsColors[1]}"></div>
                <div class="legend-label">{{ ffsClasses[1] }}</div>
            </div>
            <div class="legend-item">
                <div class="color-strip strip3" :style="{ backgroundColor:  ffsColors[2]}"></div>
                <div class="legend-label">{{ ffsClasses[2] }}</div>
            </div>
            <div class="legend-item">
                <div class="color-strip strip4" :style="{ backgroundColor:  ffsColors[3]}"></div>
                <div class="legend-label">{{ ffsClasses[3] }}</div>
            </div>
            <div class="legend-item">
                <div class="color-strip strip5" :style="{ backgroundColor:  ffsColors[4]}"></div>
                <div class="legend-label">{{ ffsClasses[4] }}</div>
                <div class="legend-label-max">{{ ffsClasses[5] }}</div>
            </div>
            <div class="mb-0 font-weight-bold">
               Wildfire Susceptibility 
            </div>
            
      </v-card-item>
      <!-- Legend for UHI -->
      <v-card-item v-if="uhi_layer_activated===true">
            <div class="legend-item">
                <div class="color-strip strip1"  :style="{ backgroundColor: uhiColors[0]}"></div>
                <div class="legend-label">{{  uhiClasses[0] }}</div>
            </div>
            <div class="legend-item">
                <div class="color-strip strip2" :style="{ backgroundColor:  uhiColors[1]}"></div>
                <div class="legend-label">{{ uhiClasses[1] }}</div>
            </div>
            <div class="legend-item">
                <div class="color-strip strip3" :style="{ backgroundColor:  uhiColors[2]}"></div>
                <div class="legend-label">{{ uhiClasses[2] }}</div>
            </div>
            <div class="legend-item">
                <div class="color-strip strip4" :style="{ backgroundColor:  uhiColors[3]}"></div>
                <div class="legend-label">{{ uhiClasses[3] }}</div>
            </div>
            <div class="legend-item">
                <div class="color-strip strip5" :style="{ backgroundColor:  uhiColors[4]}"></div>
                <div class="legend-label">{{ uhiClasses[4] }}</div>
                <div class="legend-label-max">{{ uhiClasses[5] }}</div>
            </div>
            <div class="mb-0 font-weight-bold">
               Urban Heat Island Intensity 
            </div>
            
      </v-card-item>
       <!-- Legend for Moran's I -->
      <v-card-item v-if ="uhi_activated_tab==='moran' && selectedMoranFeature!==null">
            <div class="legend-item">
                <div class="color-strip strip1"  style="background-color: #ff0000;"></div>
                <div >HH</div>
            </div>
            <div class="legend-item">
                <div class="color-strip strip2" style="background-color: #f2aa1b;"></div>
                <div >HL</div>
            </div>
            <div class="legend-item">
                <div class="color-strip strip3" style="background-color: #0000ff;"></div>
                <div >LL</div>
            </div>
            <div class="legend-item">
                <div class="color-strip strip4" style="background-color: #6ecff5;"></div>
                <div class="">LH</div>
            </div>
            
            <div class="mb-0 font-weight-bold">
              Moran's I Clusters for {{selectedMoranFeature}}
            </div>
            
      </v-card-item>
       <!-- Legend for UHI Features -->
      <v-card-item v-if="uhi_activated_tab==='feature' && selectedUHIFeatureSpecification!==null">
            <div class="legend-item">
                <div class="color-strip strip1"  :style="{ backgroundColor: selectedUHIFeatureSpecification.feature_color_palette[0]}"></div>
                <div class="legend-label-upper-bounds">{{  selectedUHIFeatureSpecification.feature_classes[1].toFixed(2) }}</div>
            </div>
            <div class="legend-item">
                <div class="color-strip strip2" :style="{ backgroundColor:  selectedUHIFeatureSpecification.feature_color_palette[1]}"></div>
                <div class="legend-label-upper-bounds">{{  selectedUHIFeatureSpecification.feature_classes[2].toFixed(2) }}</div>
            </div>
            <div class="legend-item">
                <div class="color-strip strip3" :style="{ backgroundColor:  selectedUHIFeatureSpecification.feature_color_palette[2]}"></div>
                <div class="legend-label-upper-bounds">{{  selectedUHIFeatureSpecification.feature_classes[3].toFixed(2) }}</div>
            </div>
            <div class="legend-item">
                <div class="color-strip strip4" :style="{ backgroundColor:  selectedUHIFeatureSpecification.feature_color_palette[3]}"></div>
                <div class="legend-label-upper-bounds">{{  selectedUHIFeatureSpecification.feature_classes[4].toFixed(2) }}</div>
            </div>
            <div class="legend-item">
                <div class="color-strip strip5" :style="{ backgroundColor:  selectedUHIFeatureSpecification.feature_color_palette[4]}"></div>
                <div class="legend-label-upper-bounds">{{  selectedUHIFeatureSpecification.feature_classes[5].toFixed(2) }}</div>
            </div>
            <div class="mb-0 font-weight-bold">
               {{ selectedUHIFeatureSpecification.name }}
            </div>
            
      </v-card-item>
       <!-- Legend for UHI SHAP -->
      <v-card-item v-if="uhi_activated_tab==='shap' && selectedUHIShapSpecification!==null">
            <div class="legend-item">
                <div class="color-strip strip1"  :style="{ backgroundColor: selectedUHIShapSpecification.shap_color_palette[0]}"></div>
                <div class="legend-label-upper-bounds">{{  selectedUHIShapSpecification.shap_classes[1].toFixed(2) }}</div>
            </div>
            <div class="legend-item">
                <div class="color-strip strip2" :style="{ backgroundColor:  selectedUHIShapSpecification.shap_color_palette[1]}"></div>
                <div class="legend-label-upper-bounds">{{  selectedUHIShapSpecification.shap_classes[2].toFixed(2) }}</div>
            </div>
            <div class="legend-item">
                <div class="color-strip strip3" :style="{ backgroundColor:  selectedUHIShapSpecification.shap_color_palette[2]}"></div>
                <div class="legend-label-upper-bounds">{{  selectedUHIShapSpecification.shap_classes[3].toFixed(2) }}</div>
            </div>
            <div class="legend-item">
                <div class="color-strip strip4" :style="{ backgroundColor:  selectedUHIShapSpecification.shap_color_palette[3]}"></div>
                <div class="legend-label-upper-bounds">{{  selectedUHIShapSpecification.shap_classes[4].toFixed(2) }}</div>
            </div>
            <div class="legend-item">
                <div class="color-strip strip5" :style="{ backgroundColor:  selectedUHIShapSpecification.shap_color_palette[4]}"></div>
                <div class="legend-label-upper-bounds">{{  selectedUHIShapSpecification.shap_classes[5].toFixed(2) }}</div>
            </div>
            <div class="mb-0 font-weight-bold">
               {{ selectedUHIShapSpecification.name }} SHAP Values
            </div>
            
      </v-card-item>
       <v-card-item  v-if="uhi_activated_tab==='bivariate'">
            <div class="bivariate-legend-container">
                <span style="text-orientation: mixed;  writing-mode: vertical-rl; margin-top: -35px;"> 

                       {{selectedUHIBivariateFeatureSpecification.name }}
                </span>
                    
                <div class="bivariate-y-axis">
                    <span style="margin-top: -20px;">High</span>
                    <span style="font-weight: bold; font-size: 1.5rem; margin-top: -15px;">&uarr;</span>
                    <span>Low</span>
                        
                 </div>
                    
                    

                <!-- Legend Grid -->
                <div class="bivariate-legend">
                
                    <div class="uhi-bivariate-legend-grid">
                        <div
                            v-for="(color, index) in selectedUHIBivariateFeatureSpecification.colorPalette"
                            :key="index"
                            :id="'bivariate'+index"
                            :style="{ backgroundColor: color }"
                            class="uhi-bivariate-legend-cell"
                        >
                        <!--<span class="bivariate-legend-label">{{ key.replace('_', ' / ') }}</span>-->
                        </div>
                    </div>

                    <!-- X-axis Labels and Arrow -->
                    <div class="bivariate-x-axis">
                        <span>Low</span>
                        
                        <span style="font-weight: bold; font-size: 1.5rem;">&rarr;</span>
                        
                        <span>High</span>
                    </div>
                    <span> 
                    
                   {{selectedUHIBivariateFeatureSpecification.secondVariable.name }}
                    </span>
                    
                
                    
                </div>
            </div>
        </v-card-item>
      <!-- Legend for noise grain size UHI -->
      <v-card-item v-if="uhi_activated_tab=='ternary' && uncertainty==true">
        <div  v-for="(thickness, index) in stripeThicknesses"
            :key="index"
            style="font-size: 0.7rem; display: inline-block;">
            <img
              class="legend-item"
              :class="index === 4 ? 'mr-0' : 'mr-6'"
              :src="`legend_items/noise_grain_${index+1}.png`"
              style="width: 40px; height: 40px;"
            />
        </div>
        <div class="legend-arrow-container mt-4">
              <div class="legend-arrow-label" style="float: left;">Uncertain</div>
              <div class="uncertainty-square-arrow"></div>
              <div class="legend-arrow-label" style="float: right;">Certain</div>
        </div>
          
      </v-card-item>
        
    </v-card>
</template>
<script setup>
import {ref} from 'vue'
import { storeToRefs } from 'pinia'
import { useMapLegendStore } from '../stores/mapLegend'
import { useMetadataDialogStore } from '../stores/metadataDialog'
import featureMetadata from '../assets/featureMetadata'
import { useUhiStore } from '../stores/uhi'
let {uncertainty}= storeToRefs( useUhiStore())

const stripeSpacing = 9; // Constant spacing
const stripeThicknesses = [1, 3, 5, 7, 9]; // Varying stripe widths

function getStripeStyle(thickness) {
  return {
    backgroundImage: `repeating-linear-gradient(
      90deg,
      #000 0px,
      #000 ${thickness}px,
      transparent ${thickness}px,
      transparent ${stripeSpacing}px
    )`
  };
}
const stripeWidth = 3;
const stripeAngles = [80, 45, 0, -45, -90];

function getStripeAngleStyle(angle) {
  return {
    backgroundImage: `repeating-linear-gradient(
      ${angle}deg,
      #000 0px,
      #000 ${stripeWidth}px,
      transparent ${stripeWidth}px,
      transparent ${stripeSpacing}px
    )`,
  };
}
const arrowVisHeights = [10, 15, 20, 25, 30]; // Adjust heights as needed
const arrowVisWidth = [5, 10, 15, 20, 25]; // Adjust heights as needed
const metadataDialogStore = useMetadataDialogStore();
let { minMax, classIntervalsAndColor, rasterLegendUrl, rasterLegendTitle, activatedGeovisStyle, firstProperties, firstPropertiesClassIntervals, secondProperties,secondPropertiesClassIntervals, selectedColorPalette, uncertaintyStyle, legendVisVar1, legendVisVar2, ffs_layer_activated, selectedMoranFeature, uhi_layer_activated, uhi_activated_tab, selectedUHIFeatureSpecification, selectedUHIShapSpecification, selectedUHIBivariateFeatureSpecification} = storeToRefs(useMapLegendStore())
let  bivariateColorpalette= ref({
  'high_low': '#be64ac', 'high_medium': '#8c62aa', 'high_high':'#3b4994',
  'medium_low': '#dfb0d6', 'medium_medium': '#a5add3', 'medium_high':'#5698b9',
  'low_low': '#e8e8e8', 'low_medium': '#ace4e4', 'low_high':'#5ac8c8'
}) 

let accumulativeFeatureColor = ref({
    'aspect':'#a6cee3', 'dem':'#1f78b4', 'ndvi':'#b2df8a', 'slope':'#33a02c', 'drought_index':'#fb9a99',
    'global_radiation':'#e31a1c', 'gndvi':'#fdbf6f', 'landcover':'#ff7f00', 'ndmi':'#cab2d6', 'precipitation':'#6a3d9a', 'lst':'#ffff99'
})
let ffsClasses = [0, 0.016, 0.068, 0.08, 0.147, 1]
let uhiClasses = [23.02, 27.44, 30.74, 33.24, 35.52, 50.74]

    //5-class Reds from ColorBrewer
let ffsColors =['#fee5d9','#fcae91','#fb6a4a','#de2d26','#a50f15']
let uhiColors =["#2b83ba","#abdda4","#ffffbf","#fdae61","#d7191c"]
const showMetadata = (featureName) =>{
    metadataDialogStore.assignMetadata(featureMetadata[featureName].metadata, featureName)

}
</script>

<style scoped>

.legend-ui {
    position: absolute;
    scale: 1.18;
    right: 35px;
    bottom: 10px;
    z-index:10;
    background: white;
    background-color: rgba(255,255,255,1);
    backdrop-filter: blur(5px);
    -webkit-backdrop-filter: blur(5px);
    -moz-backdrop-filter: blur(5px);
    -ms-backdrop-filter: blur(5px);
    width: auto;
    border-radius: 8px;
}
.color-strip {
  width: 60px; 
  height: 12px; 
  display: inline-block; 
}

.legend-item {
    display: inline-block; 

  
}

.legend-label {
  text-align: left;
  font-size: 0.7rem;
}
.legend-label-upper-bounds {
  text-align: right;
  font-size: 0.7rem;
}
.legend-label-max {
    position: absolute;
    top:30px;
    left: 300px;
    white-space: normal;
    justify-content: center;
    font-size: 0.7rem;
}
.bivariate-legend-container {
  display: flex;
  align-items: center;
  justify-content: center;
}

.bivariate-legend {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.bivariate-legend-grid {
  display: grid;
  grid-template-columns: repeat(3, 50px); /* 3 columns */
  grid-template-rows: repeat(3, 50px); /* 3 rows */
  gap: 0px;
}

.uhi-bivariate-legend-grid {
  display: grid;
  grid-template-columns: repeat(5, 30px);
  grid-template-rows: repeat(5, 30px);
  transform: rotateX(180deg);
}

.uhi-bivariate-legend-cell {
  transform: rotateX(180deg);
}

.bivariate-legend-cell {
  width: 50px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.bivariate-legend-label {
  font-size: 0.8rem;
  color: #333;
  text-align: center;
}

/* X-axis Labels and Arrow */
.bivariate-x-axis {
  display: flex;
  justify-content: space-between;
  width: 150px; /* To match the width of the grid */
  margin-top: 5px;
  font-size: 0.7rem;
  text-align: center;
}

/* Y-axis Labels and Arrow */
.bivariate-y-axis {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 150px; /* To match the height of the grid */
  margin-right: 5px;
  margin-bottom: 15px;
  font-size: 0.7rem;
  text-align: center;
}

.label-container {
    display: flex;
    flex-direction: columnrow; /* Horizontal layout */
    gap: 30px; /* Optional: space between items */
    align-items: center; /* Align items vertically in the center */
    font-size: 0.7rem;
}

.circle {
  position: relative;
  width: 100px;
  height: 100px;
  border: 1px solid black;
  border-radius: 50%;
  margin-left: 32%;
  }

.point {
  position: absolute;
  width: 7px;
  height: 7px;
  background-color: red;
  border-radius: 50%;
}

.center {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.edge {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(225deg) translateX(50px);
}

.arrow {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 50px;
  height: 1.5px;
  background-color: rgb(14, 8, 8);
  transform-origin: left center;
  transform: rotate(225deg);
}

.arrow::after {
  content: '';
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-top: 4px solid transparent;
  border-bottom: 4px solid transparent;
  border-left: 8px solid rgb(11, 11, 11);
}
.label {
  position: absolute;
  color: black;
  font-size: 12px;
  font-family: sans-serif;
}

.center-label {
  top: 90%;
  left: 50%;
  transform: translate(-50%, -150%); /* above center point */
}

.edge-label {
  top: 40%;
  left: 10%;
  transform: rotate(225deg) translateX(65px) rotate(-225deg); /* follow arrow direction */
}



.fuzzy-circle {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: radial-gradient(circle, black 0%, transparent 80%);
}

.level-very-low {
  background: radial-gradient(circle, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 1) 100%);
}

/* Low Uncertainty — small fade */
.level-low {
  background: radial-gradient(circle, rgba(0, 0, 0, 1) 40%, rgba(0, 0, 0, 0.1) 100%);
}

/* Medium Uncertainty — moderate fade */
.level-medium {
  background: radial-gradient(circle, rgba(0, 0, 0, 0.8) 30%, rgba(0, 0, 0, 0.05) 100%);
}

/* High Uncertainty — noticeable fuzzy edge */
.level-high {
  background: radial-gradient(circle, rgba(0, 0, 0, 0.6) 20%, rgba(0, 0, 0, 0) 100%);
}

/* Very High Uncertainty — almost invisible center */
.level-very-high {
  background: radial-gradient(circle, rgba(0, 0, 0, 0.4) 10%, rgba(0, 0, 0, 0) 100%);
}

.ink-circle {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: radial-gradient(circle, #000000 100%, #000000 100%);
 -webkit-mask-image: radial-gradient(circle, transparent 100%, black 100%);
  mask-image: radial-gradient(circle, transparent 100%, black 100%);
}

/* Very Low — mostly solid, sharp edge */
.ink-level-very-low {
   -webkit-mask-image: radial-gradient(circle, transparent 60%, black 100%);
  mask-image: radial-gradient(circle, transparent 60%, black 100%);
}

/* Low Uncertainty — moderate edge blur */
.ink-level-low {
   -webkit-mask-image: radial-gradient(circle, transparent 50%, black 100%);
  mask-image: radial-gradient(circle, transparent 50%, black 100%);
}

/* Medium Uncertainty — center less visible */
.ink-level-medium {
    -webkit-mask-image: radial-gradient(circle, transparent 40%, black 100%);
  mask-image: radial-gradient(circle, transparent 40%, black 100%);
}

/* High Uncertainty — strong fade inward */
.ink-level-high {
   -webkit-mask-image: radial-gradient(circle, transparent 20%, black 100%);
  mask-image: radial-gradient(circle, transparent 20%, black 100%);
}

/* Very High Uncertainty — center nearly invisible */
.ink-level-very-high {
  -webkit-mask-image: radial-gradient(circle, transparent 10%, black 100%);
  mask-image: radial-gradient(circle, transparent 10%, black 100%);
}

.circle-very-high{
  width: 58px;
  height: 58px;
  border-radius: 50%;
  border: 2px solid black;
}
.circle-high{
 width: 43px;
  height: 43px;
  border-radius: 50%;
  border: 2px solid black;
}
.circle-medium{
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: 2px solid black;
}
.circle-low{
 width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid black;
}
.circle-very-low{
  width: 10px;
  height: 10px;
  border-radius: 50%;
  border: 2px solid black;
}
.diagonal-line {
  position: absolute;
  bottom: calc(58px); /* top of the very-low circle */
  left: 30px;
  width: calc(60px * 4 + 12px); /* total horizontal span across 5 circles + gaps */
  border-top: 1px solid rgb(43, 41, 41);
  transform: rotate(-12deg); /* adjust angle visually */
  transform-origin: top left;
}
.horizontal-line {
  position: absolute;
  bottom: calc(50px); /* top of the very-low circle */
  left: 30px;
  width: calc(60px * 4 + 14px); /* total horizontal span across 5 circles + gaps */
  border-top: 1px solid rgb(43, 41, 41);
  transform: rotate(0deg); /* adjust angle visually */
  transform-origin: top left;
}
.square-very-high{
  width: 53px;
  height: 53px;
  border: 2px solid black;
}
.square-high{
 width: 40px;
  height: 40px;
  border: 2px solid black;
}
.square-medium{
  width: 30px;
  height: 30px;
  border: 2px solid black;
}
.square-low{
 width: 20px;
  height: 20px;
  border: 2px solid black;
}
.square-very-low{
  width: 10px;
  height: 10px;
  border: 2px solid black;
}

.square-pattern-width {
  width: 30px;
  height: 30px;
  border: 1px solid #ccc;
}
.uncertainty-square-arrow {
  flex: 1;
  height: 1px;
  background: black;
  position: relative;
  margin: 0 4px;
}

.uncertainty-square-arrow::before,
.uncertainty-square-arrow::after {
  content: "";
  position: absolute;
  top: -4px;
  width: 0;
  height: 0;
  border-style: solid;
}

.uncertainty-square-arrow::before {
  left: 0;
  border-width: 4px 5px 4px 0;
  border-color: transparent black transparent transparent;
}

.uncertainty-square-arrow::after {
  right: 0;
  border-width: 4px 0 4px 5px;
  border-color: transparent transparent transparent black;
}
.arrow-wrapper {
  display: flex;
  align-items: flex-end;
  justify-content: center;
  gap: 16px;
}

.arrow-column {
  display: flex;
  flex-direction: column;
  align-items: center;
}


.arrow-vis {
  width: 6px;
  background: black;
}

.arrow-label {
  font-size: 0.6rem;
  margin-top: 6px;
  text-align: center;
}

.arrow-vis-uncertainty {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 50px;
  height: 1.5px;
  background-color: rgb(14, 8, 8);
  transform-origin: left center;
  transform: rotate(-90deg);
}

.arrow-vis-uncertainty::after {
  content: '';
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-top: 4px solid transparent;
  border-bottom: 4px solid transparent;
  border-left: 8px solid rgb(11, 11, 11);
}
.arrow-vis-uncertainty-low{
  position: absolute;
  top: 50%;
  left: 50%;
  width: 50px;
  height: 1.5px;
  background-color: rgb(11, 11, 11, 0.3);
  transform-origin: left center;
  transform: rotate(-45deg);
}
.arrow-vis-uncertainty-low::after {
  content: '';
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-top: 4px solid transparent;
  border-bottom: 4px solid transparent;
  border-left: 8px solid rgb(11, 11, 11, 0.3);
}
.arrow-vis-uncertainty-medium {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 50px;
  height: 1.5px;
  background-color: rgb(11, 11, 11, 0.3);
  transform-origin: left center;
  transform: rotate(0deg);
}
.arrow-vis-uncertainty-medium::after {
  content: '';
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-top: 4px solid transparent;
  border-bottom: 4px solid transparent;
  border-left: 8px solid rgb(11, 11, 11, 0.3);
}
.arrow-vis-uncertainty-high {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 50px;
  height: 1.5px;
  background-color: rgb(11, 11, 11, 0.3);
  transform-origin: left center;
  transform: rotate(45deg);
}
.arrow-vis-uncertainty-high::after {
  content: '';
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-top: 4px solid transparent;
  border-bottom: 4px solid transparent;
  border-left: 8px solid rgb(11, 11, 11, 0.3);
}
.arrow-vis-uncertainty-down {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 50px;
  height: 1.5px;
  background-color: rgb(14, 8, 8);
  transform-origin: left center;
  transform: rotate(90deg);
}

.arrow-vis-uncertainty-down::after {
  content: '';
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-top: 4px solid transparent;
  border-bottom: 4px solid transparent;
  border-left: 8px solid rgb(11, 11, 11);
}


.arrow-vis-uncertainty-label {
  top:10%;
  left: 50%;
  transform: translate(-50%, -150%); /* above center point */
}

.arrow-vis-uncertainty-label-down {
  top: 130%;
  left: 50%;
  transform: translate(-50%, -150%);
}

</style>